import { render, staticRenderFns } from "./MyStocks.vue?vue&type=template&id=34497464&scoped=true&"
import script from "./MyStocks.vue?vue&type=script&lang=js&"
export * from "./MyStocks.vue?vue&type=script&lang=js&"
import style0 from "./MyStocks.vue?vue&type=style&index=0&id=34497464&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34497464",
  null
  
)

export default component.exports